<!-- Profile Button -->
<button mat-button [matMenuTriggerFor]="profileMenu" class="profile-button">
  <div class="profile-content">
    @if (userProfile()) {
      @if (!avatarUrl() && !userProfile()!.picture && !userProfile()!.pictureUrl) {
        <div
          class="profile-avatar"
          [style.background-color]="avatarPlaceholderColor()"
        >
          {{
            userProfile()!.name?.charAt(0) ||
              userProfile()!.email.charAt(0) ||
              (currentAccount() ? currentAccount()!.user.initials : "U")
          }}
        </div>
      }
      @if (avatarUrl() || userProfile()!.picture || userProfile()!.pictureUrl) {
        <div class="profile-avatar profile-avatar-image">
          <img
            [src]="avatarUrl() || userProfile()!.picture || userProfile()!.pictureUrl"
            alt="User Avatar"
          />
        </div>
      }
      <div class="profile-info">
        <span class="profile-name">{{ userProfile()!.name || "User" }}</span>
        <span class="profile-email">{{ userProfile()!.email || "" }}</span>
      </div>
    } @else {
      @if (avatarUrl()) {
        <div class="profile-avatar profile-avatar-image">
          <img [src]="avatarUrl()" alt="User Avatar" />
        </div>
      }
      @if (!avatarUrl() && currentAccount()) {
        <div
          class="profile-avatar"
          [ngStyle]="{ 'background-color': currentAccount()!.color }"
        >
          {{ currentAccount()!.user.initials || "U" }}
        </div>
      }
      @if (currentAccount()) {
        <div class="profile-info">
          <span class="profile-name">
            {{ currentAccount()!.user.firstName }}
            {{ currentAccount()!.user.lastName }}
          </span>
          <span class="profile-email">{{ currentAccount()!.user.email }}</span>
        </div>
      }
    }

    <mat-icon class="expand-icon">expand_more</mat-icon>
  </div>
</button>

<!-- Profile Menu -->
<mat-menu #profileMenu="matMenu" class="profile-menu">
  <div class="min-w-[264px] max-w-[320px] overflow-hidden">
    <!-- Account Settings -->
    <button
      mat-menu-item
      routerLink="/settings"
      class="py-3 px-4 min-h-12 hover:bg-black/5"
    >
      <div class="flex items-center gap-3">
        <mat-icon class="text-gray-500 mr-1">person</mat-icon>
        <span class="text-sm font-medium text-gray-800">Account Settings</span>
      </div>
    </button>

    <!-- Help -->
    <button
      mat-menu-item
      routerLink="/help"
      class="py-3 px-4 min-h-12 hover:bg-black/5"
    >
      <div class="flex items-center gap-3">
        <mat-icon class="text-gray-500 mr-1">help</mat-icon>
        <span class="text-sm font-medium text-gray-800">Help</span>
      </div>
    </button>

    <mat-divider></mat-divider>

    <!-- Logout Button -->
    <button
      mat-menu-item
      (click)="logout()"
      class="py-3 px-4 min-h-12 hover:bg-black/5"
    >
      <div class="flex items-center gap-3">
        <mat-icon class="text-red-600 mr-1">logout</mat-icon>
        <span class="text-sm font-medium text-red-600">Logout</span>
      </div>
    </button>
  </div>
</mat-menu>
